module.exports = __webpack_public_path__ + "img/de.69ccebc7.svg";